import Rive, {Layout} from "rive-react";
import bgRiv from "../../assets/img/background/bg_sekilas_gemilang.riv";
import Moment from "moment";
import React, {useEffect, useRef, useState} from "react";
import {postDanai} from "../util/ajax";
import {formatNumberToIndonesian, numberWithSeparator} from "../util/common";

export default function StatistikDanai(){
    const [totalAkumulasiPinjaman, setTotalAkumulasiPinjaman] = useState("-")
    const [totalAkumulasiPinjamanYear, setTotalAkumulasiPinjamanYear] = useState("-")
    const [totalAkumulasiPinjamanSejakBerdiri, setTotalAkumulasiPinjamanSejakBerdiri] = useState("-")
    const [totalOutstandingPinjaman, setTotalOutstandingPinjaman] = useState("-")

    const [totalBorrowerMonthly, setTotalBorrowerMonthly] = useState("-")
    const [totalBorrowerYearly, setTotalBorrowerYearly] = useState("-")
    const [totalBorrowerFromStart, setTotalBorrowerFromStart] = useState("-")
    const [totalLenderMonthly, setTotalLenderMonthly] = useState("-")
    const [totalLenderYearly, setTotalLenderYearly] = useState("-")
    const [totalLenderFromStart, setTotalLenderFromStart] = useState("-")
    const [dateUpdated, setDateUpdated] = useState("-")

    useEffect(() => {
        postDanai(process.env.REACT_APP_MOBILE_API_URL + '/p2p-mobile-api/rest/customerWeb/statistic', function (resp) {
            setTotalAkumulasiPinjamanSejakBerdiri(formatNumberToIndonesian(resp.totalAkumulasiPinjamanSejakBerdiri));
            setTotalAkumulasiPinjamanYear(formatNumberToIndonesian(resp.totalAkumulasiPinjamanYear));
            setTotalAkumulasiPinjaman(formatNumberToIndonesian(resp.totalAkumulasiPinjaman));
            setTotalOutstandingPinjaman(formatNumberToIndonesian(resp.totalOutstandingPinjaman));
            setTotalBorrowerMonthly(numberWithSeparator(resp.totalBorrowerMonthly));
            setTotalBorrowerYearly(numberWithSeparator(resp.totalBorrowerYearly));
            setTotalBorrowerFromStart(numberWithSeparator(resp.totalBorrowerFromStart));
            setTotalLenderMonthly(numberWithSeparator(resp.totalLenderMonthly));
            setTotalLenderYearly(numberWithSeparator(resp.totalLenderYearly));
            setTotalLenderFromStart(numberWithSeparator(resp.totalLenderFromStart));
            setDateUpdated(resp.id);
            console.log(resp);
        }, function () {

        });
    }, []);

    const containerRef = useRef(null);
    const [height, setHeight] = useState("100vh"); // Default to viewport height

    useEffect(() => {
        const updateHeight = () => {
            if (containerRef.current) {
                setHeight(containerRef.current.clientHeight + "px"); // Ensure it matches the container height
            }
        };

        updateHeight(); // Initial height set
        window.addEventListener("resize", updateHeight);
        return () => window.removeEventListener("resize", updateHeight);
    }, []);
    return (
        <div ref={containerRef} className="container-2">
            <div className="rive-background" style={{height}}>
                <Rive
                    src={bgRiv}
                    layout={new Layout({fit: "cover", alignment: "center"})}
                    style={{width: "100%", height: "100%"}}
                />
            </div>
            <div className="section-title text-center relative z-1" id='informasi-statistik'>
                <h2 className="text-header">Sekilas Gemilang <span>Danai.id</span></h2>
                <p>Mengamati pencapaian dan performa yang telah dicapai melalui inovasi hingga saat ini.</p>
            </div>
            <div className="bento-grid relative z-1">
                <div className="bento top">
                    <div className="bento-item item1">
                        <p>Outstanding Pinjaman</p>
                        <div className="title">Rp {totalOutstandingPinjaman}</div>
                    </div>
                </div>
                <div className="bento bottom">
                    <div className="bento-item item2">
                        <div className="title">Rp {totalAkumulasiPinjamanSejakBerdiri}</div>
                        <p>Nilai Pendanaan Tersalurkan 
                            <br/>
                            <span>Sejak Tahun Berdiri</span>
                        </p>
                    </div>
                    <div className="bento-item item3">
                        <div className="title">Rp {totalAkumulasiPinjamanYear}</div>
                        <p>Nilai Pendanaan Tersalurkan 
                            <br/>
                            <span>Pada Tahun Berjalan</span>
                        </p>
                    </div>
                    <div className="bento-item item4">
                        <div className="title">Rp {totalAkumulasiPinjaman}</div>
                        <p>Nilai Pendanaan Tersalurkan 
                            <br/>
                            <span>Per Bulan Berjalan</span>
                        </p>
                    </div>
                    <div className="bento-item item5">
                        <div className="title">{totalLenderFromStart}</div>
                        <p>Jumlah Pemberi Dana
                            <br/>
                            <span>Sejak Tahun Berdiri</span>
                        </p>
                    </div>
                    <div className="bento-item item6">
                        <div className="title">{totalLenderYearly}</div>
                        <p>Jumlah Pemberi Dana
                            <br/>
                            <span>Pada Tahun Berjalan</span>
                        </p>
                    </div>
                    <div className="bento-item item7">
                        <div className="title">{totalLenderMonthly}</div>
                        <p>Jumlah Pemberi Dana 
                            <br/>
                            <span>Per Bulan Berjalan</span>
                        </p>
                    </div>
                    <div className="bento-item item8">
                        <div className="title">{totalBorrowerFromStart}</div>
                        <p>Jumlah Penerima Dana
                            <br/>
                            <span>Sejak Tahun Berdiri</span>
                        </p>
                    </div>
                    <div className="bento-item item9">
                        <div className="title">{totalBorrowerYearly}</div>
                        <p>Jumlah Penerima Dana
                            <br/>
                            <span>Pada Tahun Berjalan</span>
                        </p>
                    </div>
                    <div className="bento-item item10">
                        <div className="title">{totalBorrowerMonthly}</div>
                        <p>Jumlah Penerima Dana
                            <br/>
                            <span>Per Bulan Berjalan</span>
                        </p>
                    </div>
                </div>
                <p id="desc">*Data diambil per tanggal
                    <span id="stat-date">&ensp;{Moment(dateUpdated, "YYYYMMDD").format("DD MMMM YYYY")}</span></p>
            </div>
        </div>
    );
}